import React from 'react';
import Button from './Button';
import Icon from '../AppIcon';

const NavigationToggle = ({ isOpen = false, onToggle, className = '' }) => {
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={onToggle}
      className={`lg:hidden fixed top-4 right-4 z-50 bg-card border border-border shadow-md hover:shadow-lg transition-all duration-150 ${className}`}
      aria-label={isOpen ? 'بستن منو' : 'باز کردن منو'}>
      <Icon
        name={isOpen ? 'X' : 'Menu'}
        size={20}
        className="text-foreground"
      />
    </Button>
  );
};

export default NavigationToggle;
